import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { FieldsToEditRequirementFragmentDoc } from '../../../fragments/fieldsToEditRequirement.generated';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { KeywordTagFieldsFragmentDoc } from '../../../fragments/keywordTagFields.generated';
import { ParagraphFieldsFragmentDoc } from '../../../fragments/paragraphFields.generated';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequirementDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type RequirementDetailsQuery = { __typename?: 'Query', requirement?: { __typename?: 'Requirement', name: string, anonymous: boolean, requirementId?: string | null, createdAt?: any | null, changeType: Types.RequirementChangeType, version?: string | null, category: Types.RequirementCategory, modifiedAt?: any | null, id: string, status: Types.RequirementStatus, definition?: string | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, assignedParagraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, parent: { __typename?: 'RegulatoryDocument', id: string, name: string, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string }> }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', name: string, id: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, parentRef?: { __typename?: 'Requirement', id: string, name: string, version?: string | null } | null, childrenRefs?: Array<{ __typename?: 'Requirement', id: string, name: string, version?: string | null, status: Types.RequirementStatus }> | null, approvalWorkFlow?: { __typename?: 'ApprovalWorkFlow', clearingTimestamp?: any | null, message?: string | null, sentToApprovalTimestamp?: any | null, approverRefs: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }> } | null, auditLog: Array<{ __typename: 'AuditLog', entityId: string, changeSetId: any, entityType: string, entityOperation: Types.EntityOperation, createdAt: any, id: string, entity?: { __typename: 'ActiveTypeMarket', id: string } | { __typename: 'AttachmentCategory', id: string } | { __typename: 'AuditLog', id: string } | { __typename: 'BodyworkVariant', id: string } | { __typename: 'Category', id: string } | { __typename: 'Convolute', id: string } | { __typename: 'Country', id: string } | { __typename: 'DocumentSource', id: string } | { __typename: 'DriveVariant', id: string } | { __typename: 'EngineVariant', id: string } | { __typename: 'GdprRule', id: string } | { __typename: 'GearboxVariant', id: string } | { __typename: 'GetexRegulation', id: string } | { __typename: 'GlobalAnnouncement', id: string } | { __typename: 'IcsCode', id: string } | { __typename: 'Keyword', id: string } | { __typename: 'Market', id: string } | { __typename: 'PermissionGroup', id: string } | { __typename: 'PogisDocument', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionCategory', id: string } | { __typename: 'Reference', id: string } | { __typename: 'Regulation', id: string } | { __typename: 'RegulationCluster', id: string } | { __typename: 'RegulatoryDocument', id: string } | { __typename: 'Requirement', id: string } | { __typename: 'Simulation', id: string } | { __typename: 'SimulationVehicleProject', id: string } | { __typename: 'StandardPlusPcmsCluster', id: string } | { __typename: 'Subscription', id: string } | { __typename: 'SystemLevel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'User', id: string } | { __typename: 'VehicleCategory', id: string } | { __typename: 'VehicleProject', id: string } | { __typename: 'VexCluster', id: string } | { __typename: 'Vko', id: string } | null, change: { __typename: 'AuditLogChange', value?: any | null, oldValue?: any | null, nodeId?: string | null, oldNodeId?: string | null, type: string, key: string, path: string }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> } | null };


export const RequirementDetailsDocument = gql`
    query RequirementDetails($id: ID!) {
  requirement(id: $id) {
    ...FieldsToEditRequirement
    name
    anonymous
    requirementId
    createdAt
    changeType
    version
    category
    attachments {
      ...AttachmentFields
    }
    createdBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    modifiedAt
    modifiedBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    markets {
      id
      name
    }
    keywords {
      ...KeywordTagFields
    }
    assignedParagraphs {
      ...ParagraphFields
      parent {
        id
        name
        workflow {
          status
        }
        regulation {
          id
          name
          regulationNumber
        }
      }
    }
    documentReferences {
      reference {
        name
      }
      requirementReferences {
        id
        name
      }
    }
    parentRef {
      id
      name
      version
    }
    childrenRefs {
      id
      name
      version
      status
    }
    approvalWorkFlow {
      clearingTimestamp
      message
      sentToApprovalTimestamp
      approverRefs {
        givenName
        id
        mail
        name
        surname
        userPrincipalName
      }
    }
    auditLog {
      entityId
      changeSetId
      entity {
        id
        __typename
      }
      change {
        value
        oldValue
        nodeId
        oldNodeId
        type
        key
        path
        __typename
      }
      entityType
      entityOperation
      createdAt
      createdBy {
        ...UserFields
      }
      id
      __typename
    }
  }
}
    ${FieldsToEditRequirementFragmentDoc}
${AttachmentFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${ParagraphFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useRequirementDetailsQuery__
 *
 * To run a query within a React component, call `useRequirementDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequirementDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequirementDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequirementDetailsQuery(baseOptions: Apollo.QueryHookOptions<RequirementDetailsQuery, RequirementDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequirementDetailsQuery, RequirementDetailsQueryVariables>(RequirementDetailsDocument, options);
      }
export function useRequirementDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequirementDetailsQuery, RequirementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequirementDetailsQuery, RequirementDetailsQueryVariables>(RequirementDetailsDocument, options);
        }
export type RequirementDetailsQueryHookResult = ReturnType<typeof useRequirementDetailsQuery>;
export type RequirementDetailsLazyQueryHookResult = ReturnType<typeof useRequirementDetailsLazyQuery>;
export type RequirementDetailsQueryResult = Apollo.QueryResult<RequirementDetailsQuery, RequirementDetailsQueryVariables>;